<template>
  <footer class="footer no-print">
    <div class="container-fluid">
      <nav>
        <ul class="nav">
          <li class="nav-item">
            <a
              :href="companyUrl"
              target="_blank"
              class="nav-link"
            >
              {{ companyName }}
            </a>
          </li>
          <!--            <li class="nav-item">-->
          <!--              <a-->
          <!--                href="https://example.com/about"-->
          <!--                target="_blank"-->
          <!--                rel="noopener"-->
          <!--                class="nav-link"-->
          <!--              >-->
          <!--                About Us-->
          <!--              </a>-->
          <!--            </li>-->
          <!--            <li class="nav-item">-->
          <!--              <a-->
          <!--                href="https://example.com/contact"-->
          <!--                target="_blank"-->
          <!--                rel="noopener"-->
          <!--                class="nav-link"-->
          <!--              >-->
          <!--                Contacts-->
          <!--              </a>-->
          <!--            </li>-->
        </ul>
      </nav>
      <div class="copyright">
        {{ year }}, &copy; all rights reserved
      </div>
    </div>
  </footer>
</template>
<script>

export default {
  props: {
    companyName: {
      type: String,
      default: ""
    },
    companyUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
};
</script>
<style></style>
